<script setup lang="ts">
import ContactSection from '@/components/ContactSection.vue';
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import HeroSection from '@/components/HeroSection.vue';
import RebrandAnnouncement from '@/components/RebrandAnnouncement.vue';
import ProjectMissionSection from '@/components/ProjectMissionSection.vue';
import StatisticsSection from '@/components/StatisticsSection.vue';
import TechnologySection from '@/components/TechnologySection.vue';
import { Head } from '@inertiajs/vue3';
</script>

<template>
    <Head>
        <title>Digital Safe - banknote asset protection platform</title>
        <meta
            head-key="description"
            name="description"
            content="Digital Safe helps households, companies and institutions register, verify and protect cash assets with secure digital certificates and blockchain-backed transparency."
        />
        <meta
            name="keywords"
            content="Digital Safe, cash protection, banknote security, financial asset security, blockchain certificate, XEN Network, CyfrowyZłoty"
        />
    </Head>
    <div class="min-h-screen bg-background">
        <Header />
        <main>
            <RebrandAnnouncement />
            <HeroSection />
            <ProjectMissionSection />
            <StatisticsSection />
            <TechnologySection />
            <ContactSection />
        </main>
        <Footer />
    </div>
</template>
